<template>
  <TypesContext
    v-if="accountId"
    :fallback-redirect="{
      name: '/account/profile/',
    }"
    :organization-id="accountId"
  >
    <RouterView></RouterView>
  </TypesContext>
</template>

<script setup lang="ts">
import TypesContext from '@/components/deepbox/types/TypesContext.vue'

definePage({
  props: true,
})

defineProps({
  accountId: {
    type: String,
    required: true,
  },
})
</script>
